import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { renderIaMarkdown } from "./iaMarkdown";
import { IMAGE_END_POINT } from "../../Api/EndPoints";

/**
 * Bulle de message.
 *
 * Version allegee de Components/Sav/NewTicketSav/ChatContainer/MessageItem :
 * on garde l'alignement et le rendu HTML, on retire emoji / favoris / edition /
 * suppression qui n'ont pas de sens face a un assistant.
 *
 * Aucune source n'est affichee ici : les documents du corpus portent des noms de
 * fichiers internes qui ne doivent pas etre exposes a l'utilisateur. Le back ne
 * les transmet d'ailleurs plus au navigateur ; seule l'administration y accede.
 */
const IaMessage = ({ message, streamingText, isStreaming }) => {
  const { t } = useTranslation("common");
  const isUser = message.role === "user";
  const isError = message.status === "error";

  const images = message.images || [];
  const text = isStreaming ? streamingText : message.content;

  const imageUrl = (image) => {
    const url = image?.url || "";
    // Pendant l'envoi, l'apercu est une URL blob locale : elle ne doit pas etre
    // prefixee par le domaine des medias.
    return url.startsWith("blob:") || url.startsWith("http")
      ? url
      : `${IMAGE_END_POINT}${url}`;
  };

  return (
    <div
      className={`iaMessage d-flex flex-column mb-3 ${
        isUser ? "ms-auto align-items-end" : "me-auto align-items-start"
      }`}
    >
      <div
        className={`iaBubble br5 px-3 py-2 ${
          isUser ? "iaBgBlue text-white" : isError ? "iaBubbleError" : "bg-lightGrey"
        }`}
      >
        {images.length > 0 && (
          <div className="d-flex flex-wrap gap-2 mb-2">
            {images.map((image) => (
              <img
                key={image.id || image.url}
                src={imageUrl(image)}
                alt={image.name || ""}
                className="iaMessageImage br5"
              />
            ))}
          </div>
        )}

        {isUser ? (
          <p className="f14 normal mb-0 iaUserText">{text}</p>
        ) : isError && !text ? (
          <p className="f14 normal mb-0 text-danger">
            {message.errorMessage || t("The generation failed")}
          </p>
        ) : (
          <div
            className="f14 normal iaMarkdown"
            dangerouslySetInnerHTML={{ __html: renderIaMarkdown(text) }}
          />
        )}

        {/* Curseur de frappe tant qu'aucun token n'est encore arrive. */}
        {isStreaming && !text && (
          <span className="iaTypingDots f14">
            <span />
            <span />
            <span />
          </span>
        )}
      </div>

      <span className="f11 normal text-lightBlack mt-1">
        {message.createdAt ? moment(message.createdAt).format("HH:mm") : ""}
      </span>
    </div>
  );
};

export default IaMessage;
